<template>
    <div class="">
        <div class="max-w-2xl md:max-w-3xl bg-white mx-auto">
            <h1 class="text-3xl uppercase mb-5">Painel da Economia do Amazonas - Monitoramento Covid-19</h1>
            <h1 class="text-2xl mb-5">Obrigado!</h1>
            <h3 class="mb-12">Sua resposta foi enviada.</h3>
            <router-link class="text-blue-600 hover:underline" to="/">Ir para o início</router-link>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({})
</script>